import { WorkOrderStatusEnum } from 'gql/graphql';
import type { Position } from 'uikit';
import { Tooltip } from 'uikit';

import { useMemo } from 'react';

import { WorkOrderStatusLabels } from '../workOrderConstants';

import { TooltipNameWorkOrderKebabMenu } from './useAddItemsWorkOrderKebabMenu';

export const WorkOrderKebabMenuTooltip = ({
    activeTooltip,
    tooltipPosition,
    statusWorkOrder,
    isWorkOrderVorTypeXml,
    isHasOrderChangeValidStatus,
}: {
    activeTooltip: { [key: string]: boolean };
    tooltipPosition: Position;
    isWorkOrderVorTypeXml: boolean;
    statusWorkOrder?: WorkOrderStatusEnum;
    isHasOrderChangeValidStatus: boolean;
}) => {
    const isWorkOrderStatusOnFormation = statusWorkOrder === WorkOrderStatusEnum.OnFormation;
    const isWorkOrderStatusCompleted = statusWorkOrder === WorkOrderStatusEnum.Completed;
    const isStatusWorkOrderDelayed = statusWorkOrder === WorkOrderStatusEnum.Delayed;

    const tooltipMsgCreateChange = useMemo(() => {
        if (isWorkOrderStatusCompleted || isStatusWorkOrderDelayed) {
            return `Работа с НЗ недоступна в статусе "${statusWorkOrder && WorkOrderStatusLabels[statusWorkOrder]}"`;
        }

        if (isHasOrderChangeValidStatus) {
            return 'В составе Наряд-Заказа может быть одновременно сформировано только одно несогласованное Изм. к НЗ';
        }

        const result = isWorkOrderStatusOnFormation
            ? 'Создание Изм. к НЗ доступно только в статусе НЗ "В работе"'
            : 'Отсутствуют изменения для создания Изм. к НЗ';

        return result;
    }, [
        isHasOrderChangeValidStatus,
        isStatusWorkOrderDelayed,
        isWorkOrderStatusCompleted,
        isWorkOrderStatusOnFormation,
        statusWorkOrder,
    ]);

    const notAvailableByStatusText = `Работа с НЗ недоступна в статусе "${
        statusWorkOrder && WorkOrderStatusLabels[statusWorkOrder]
    }"`;

    return (
        <>
            {activeTooltip[TooltipNameWorkOrderKebabMenu.PreviousVersion] && (
                <Tooltip
                    size={tooltipMsgCreateChange.length > 80 ? 'm' : 's'}
                    direction="rightCenter"
                    position={tooltipPosition}
                    isInteractive={false}
                    style={{ zIndex: 2 }}
                >
                    {notAvailableByStatusText}
                </Tooltip>
            )}
            {activeTooltip[TooltipNameWorkOrderKebabMenu.CreateWorkOrderChange] && (
                <Tooltip
                    size={tooltipMsgCreateChange.length > 80 ? 'm' : 's'}
                    direction="rightCenter"
                    position={tooltipPosition}
                    isInteractive={false}
                    style={{ zIndex: 2 }}
                >
                    {tooltipMsgCreateChange}
                </Tooltip>
            )}
            {activeTooltip[TooltipNameWorkOrderKebabMenu.ReplaceVOR] && (
                <Tooltip
                    size="s"
                    direction="rightCenter"
                    position={tooltipPosition}
                    isInteractive={false}
                    style={{ zIndex: 2 }}
                >
                    {!isWorkOrderVorTypeXml
                        ? 'Доступно только для ВОР формата xml'
                        : 'В статусе НЗ "В работе" недоступна замена файла ВОР'}
                </Tooltip>
            )}
            {activeTooltip[TooltipNameWorkOrderKebabMenu.DeleteWorkOrder] && (
                <Tooltip
                    size="s"
                    direction="rightCenter"
                    position={tooltipPosition}
                    isInteractive={false}
                    style={{ zIndex: 2 }}
                >
                    {isWorkOrderStatusCompleted || isStatusWorkOrderDelayed
                        ? notAvailableByStatusText
                        : 'Удаление НЗ возможно только в статусе "На\u00A0формировании"'}
                </Tooltip>
            )}
            {activeTooltip[TooltipNameWorkOrderKebabMenu.DownloadTemplateActKC2] && (
                <Tooltip
                    size="s"
                    direction="rightCenter"
                    position={tooltipPosition}
                    isInteractive={false}
                    style={{ zIndex: 2 }}
                >
                    {isWorkOrderStatusCompleted || isStatusWorkOrderDelayed
                        ? notAvailableByStatusText
                        : 'Выгрузка шаблона доступна только в статусе НЗ "В\u00A0работе"'}
                </Tooltip>
            )}
            {activeTooltip[TooltipNameWorkOrderKebabMenu.UploadTemplateActKC2] && (
                <Tooltip
                    size="s"
                    direction="rightCenter"
                    position={tooltipPosition}
                    isInteractive={false}
                    style={{ zIndex: 2 }}
                >
                    {isWorkOrderStatusCompleted || isStatusWorkOrderDelayed
                        ? notAvailableByStatusText
                        : 'Загрузка шаблона доступна только в статусе НЗ "В\u00A0работе"'}
                </Tooltip>
            )}
        </>
    );
};

WorkOrderKebabMenuTooltip.displayName = 'WorkOrderKebabMenuTooltip';
